module.exports = __webpack_public_path__ + "img/mcu1.4e8c3089.png";